<script>
export default {
  props: {
    title: {},

    depth: {
      type: Number,
      default: 0
    },

    scrollTo: {}
  },

  data() {
    return {
      internalDepth: this.depth
    }
  },

  watch: {
    scrollTo() {
      if (!this.scrollTo) { return }
      let container = this.$refs.scrollBody
      let element = container.querySelector(this.scrollTo)
      if (element) {
        this.$scrollTo(element, 500, {container: container})
      }
    },

    internalDepth() {
      this.$emit('update:depth', this.internalDepth)
    },
    depth() {
      this.internalDepth = this.depth
    }
  }
}
</script>

<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <b-button v-if="internalDepth > 0" icon-left="chevron-left" @click="internalDepth -= 1" class="is-text">Back</b-button>
      <p class="modal-card-title">
        {{ title }}
      </p>
      <p class="has-text-right">
        <slot name="header-right"></slot>
      </p>
    </header>
    <div class="modal-card-body" ref="scrollBody">
      <slot name="body"></slot>
    </div>

    <footer class="modal-card-foot">
      <slot name="footer"></slot>
    </footer>
  </div>
</template>

<style lang="scss" scoped>
footer.modal-card-foot {
  justify-content: space-between;
}
</style>